export default __webpack_public_path__ + "static/media/teams_logo.ae215b2c.png";